import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const GrowYourPodsWrapper = styled(motion.div)<{ isMobile: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 20px;
    position: absolute;
    background: linear-gradient(116.56deg, #523df0 0%, #4b4092 101.94%);
    border-radius: 8px;
    width: 254px;
    top: 52px;
    left: -5px;
    box-sizing: border-box;
    text-align: left;
    z-index: 3;

    ${({ isMobile }) =>
        isMobile &&
        css`
            padding: 15px;
            width: 215px;
            top: 62px;
            left: 0;
        `}
`;

export const PromptHeading = styled.h3`
    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 20px;
    line-height: 21px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
    padding: 0;
    margin-bottom: 10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 24px;
        line-height: 25px;
    }
`;

export const PromptSubheading = styled.h4`
    box-sizing: border-box;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
    padding: 0;
    margin-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
        line-height: 19px;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
`;

export const TextButton = styled.p`
    font-family: 'Alliance No.1';
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.02em;
    color: #ffffff;
    margin: 0;
    padding: 0;
    cursor: pointer;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 14px;
        line-height: 14px;
    }
`;

export const PromptArrow = styled.div`
    top: -5px;
    left: 12px;
    width: 11px;
    height: 11px;
    transform: rotate(45deg);
    position: absolute;
    background-color: #523df0;
`;
